__turbopack_context__.v({
  "prose": "V6ppsa_prose",
  "tableScroll": "V6ppsa_tableScroll",
});
